<div class="row" style="padding: 5px">
	<div class="col-lg-12">
		<div class="ibox float-e-margins">
			<div class="ibox-content">
				<!--Menu Bar-->
				<div class="lock-to-top" style="background-color: #ffffff">
					<!--Buttons-->
					<div class="button-body flex">
						<button class="btn btn-primary" style="margin-left: 0px" (click)="onRefresh()">Refresh</button>

						<!--INSERT CUSTOM BUTTONS HERE-->
						<button class="btn btn-primary" style="margin-left: 5px" (click)="onPrintTimeScan()">Print Timescan</button>
					</div>
				</div>

				<!--Table-->
				<div class="table-main-body">
					<p-table
						#mydt
						[value]="lstTimeScan"
						[loading]="loading"
						[paginator]="true"
						[(rows)]="pagerows"
						[(first)]="pagefirst"
						[showCurrentPageReport]="true"
						[resizableColumns]="false"
						sortMode="multiple"
						styleClass="p-datatable-striped"
						selectionMode="single"
						[(selection)]="SelectedTimeScan"
						dataKey="TimeScanID"
						(onFilter)="onHandleFilter($event)"
						(onSort)="onHandleSort($event)"
						(onRowSelect)="onRowSelect($event)"
						(onRowUnselect)="onRowUnselect($event)"
						currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
						[rowsPerPageOptions]="[5, 10, 25, 50]"
					>
						<!--Headers-->
						<ng-template pTemplate="header">
							<!--Filter or Select from Dropdown-->
							<tr>
								<!--INSERT CUSTOM FILTERS HERE-->

								<!--EntryDate-->
								<th>
									<!-- <p-columnFilter type="text" field="EntryDate" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
								</th>

								<!--EntryDayDesc-->
								<th>
									<p-columnFilter field="EntryDayDesc" matchMode="equals" [showMenu]="false">
										<ng-template pTemplate="filter" let-value let-filter="filterCallback">
											<p-dropdown
												#filterEntryDayDesc
												[ngModel]="value"
												[options]="lstEntryDayDesc"
												(onChange)="filter($event.value)"
												placeholder="Any"
												[showClear]="true"
											>
												<ng-template let-value pTemplate="item">
													<span>{{ value }}</span>
												</ng-template>
											</p-dropdown>
										</ng-template>
									</p-columnFilter>
								</th>

								<!--TimeScanTypeDesc-->
								<th>
									<p-columnFilter field="TimeScanTypeDesc" matchMode="equals" [showMenu]="false">
										<ng-template pTemplate="filter" let-value let-filter="filterCallback">
											<p-dropdown
												#filterTimeScanTypeDesc
												[ngModel]="value"
												[options]="lstTimeScanTypeDesc"
												(onChange)="filter($event.value)"
												placeholder="Any"
												[showClear]="true"
											>
												<ng-template let-value pTemplate="item">
													<span>{{ value }}</span>
												</ng-template>
											</p-dropdown>
										</ng-template>
									</p-columnFilter>
								</th>

								<!--EntryTime-->
								<th>
									<!-- <p-columnFilter type="text" field="EntryTime" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
								</th>

								<!--ScanStation-->
								<th>
									<p-columnFilter field="ScanStation" matchMode="equals" [showMenu]="false">
										<ng-template pTemplate="filter" let-value let-filter="filterCallback">
											<p-dropdown
												#filterScanStation
												[ngModel]="value"
												[options]="lstScanStation"
												(onChange)="filter($event.value)"
												placeholder="Any"
												[showClear]="true"
											>
												<ng-template let-value pTemplate="item">
													<span>{{ value }}</span>
												</ng-template>
											</p-dropdown>
										</ng-template>
									</p-columnFilter>
								</th>
							</tr>

							<!--Column Names-->
							<tr style="height: 4rem">
								<!--INSERT CUSTOM COLUMNS HERE-->
								<th pSortableColumn="EntryDate">Date<p-sortIcon field="EntryDate"></p-sortIcon></th>
								<th pSortableColumn="EntryDayDesc">Day<p-sortIcon field="EntryDayDesc"></p-sortIcon></th>
								<th pSortableColumn="TimeScanTypeDesc">Type<p-sortIcon field="TimeScanTypeDesc"></p-sortIcon></th>
								<th pSortableColumn="EntryTime">Time<p-sortIcon field="EntryTime"></p-sortIcon></th>
								<th pSortableColumn="ScanStation">ScanStation<p-sortIcon field="ScanStation"></p-sortIcon></th>
							</tr>
						</ng-template>

						<!--Data-->
						<ng-template pTemplate="body" let-TimeScan>
							<tr [pSelectableRow]="TimeScan">
								<td *ngFor="let col of cols" style="font-weight: bold">
									{{ TimeScan[col.field] }}
								</td>
							</tr>
						</ng-template>
					</p-table>
				</div>

				<!--Error Message-->
				<div class="TopMargin">
					<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
						{{ errorMessage }}
					</div>
				</div>

				<div class="TopMargin">
					<div name="Saveing" *ngIf="isProcessing" class="alert alert-info">Processing.Please wait...</div>
				</div>
			</div>
		</div>
	</div>
</div>
